import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { handleOnGetActiveSubscriptionQueryStarted, handleOnPremiumPlansQueryStarted } from "appRedux/helpers/premiumApiHelpers"
import { GetActiveSubscriptionResponseDto, GetPremiumPlansResponseDto } from "types/premium.types"

export const premiumApi = createApi({
  reducerPath: "premiumApi",
  baseQuery: baseQueryWithMiddlewares("/premium"),
  endpoints: (builder) => ({
    plans: builder.query<GetPremiumPlansResponseDto, void>({
      query: () => "/plans",
      onQueryStarted: handleOnPremiumPlansQueryStarted
    }),
    getActiveSubscription: builder.query<GetActiveSubscriptionResponseDto, void>({
      query: () => "/active",
      onQueryStarted: handleOnGetActiveSubscriptionQueryStarted
    })
  })
})

export const {
  usePlansQuery,
  useGetActiveSubscriptionQuery
} = premiumApi
